import React from 'react'
import Grid from 'material-ui/Grid'
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'

import MapComponent from './component/MapComponent'
import routeParkingMap from '../shared/images/route-parking-map.png'

const styles = theme => ({
  container: {
    background: '#f8f8f7',
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
      margin: '56px 0'
    }
  },
  box: {
    padding: '10px',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 0'
    }
  },
  textbox:{
    padding: "15px",
    [theme.breakpoints.up('md')]: {
      paddingTop: "100px",
      textAlign: "left",
    }
  },
  content: {
    fontSize: '12px',
    padding: "10px",
    [theme.breakpoints.down('sm')]: {
      margin: "0 auto",
      padding: "0",
      width: "100%",
    }
  },
  parkingImage: {
    width: '100%',
    maxWidth: '600px',
    marginTop: '15px',
  },
  parkingNote: {
    fontSize: '11px',
    marginTop: '10px',
    lineHeight: '1.6',
  }
})

class Access extends React.Component {
  render() {
    const s = this.props.classes

    return (
      <Grid container className={s.container}>
        <Grid item xs={12} md={5}>
          <div className={s.box}>
            <div className={s.textbox}>
              <Typography variant="headline" className={s.title} style={{fontFamily: "serif"}} align="center">
                駿府城公園すぐちかく
              </Typography>
              <Typography variant="subtitle" className={s.content}>
                (平日) 火〜金曜日 9:30~18:30 / (土日祝日)9:00〜18:30 / 月曜、第3日曜は定休日<br />
                休業日 ：毎週月曜日 年末年始、夏季休業あり<br/>
                座席数 ：テーブル14席 / カウンター4席<br/>
                駐車場 ：4台（無料）<br/>
                ※リブレコインパーキング第２駐車場をご利用のお客様は、必ず駐車場券を発行してお持ちください。1,000円以上ご利用のお客様、または焙煎豆200g以上購入のお客様に30分無料チケットをお渡し致しますので、お会計の際にご提示くださいませ。<br />
                <img src={routeParkingMap} alt="駐車場ご案内" className={s.parkingImage} />
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={7}>
          <div className={s.box}>
            <MapComponent />
          </div>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(Access)



// WEBPACK FOOTER //
// ./src/frontend/client/access/index.js